import Accordion from '@base/components/src/Accordion';
import { ProductAddonElement } from '@package/core/src/shoppingCart/types';
import useSuggestedProducts from '@package/hooks/src/useSuggestedProducts';
import { memo, useEffect, useState } from 'react';
import { SuggestedProductProps } from './types';
import AddonCard from '../CartProductAddons/AddonCard';
import Addon from '../CartProductAddons/Addon';
import clsx from 'clsx';

import config from 'config-base';
import styles from '../CartProductAddons/CartProductAddons.module.css';

export function SuggestedProductsComponent({
  vendorId,
  vendorName,
  minPrice,
  products,
  addProduct,
}: SuggestedProductProps) {
  const [productsList, setProductsList] = useState<any>([]);

  const { suggestedProducts } = useSuggestedProducts(products, vendorId, minPrice);

  useEffect(() => {
    if (suggestedProducts) setProductsList(suggestedProducts);
  }, [suggestedProducts]);

  return productsList && productsList.length > 0 ? (
    <Accordion
      title={`Other ${vendorName} products`}
      className={clsx(styles.addon, {
        [styles.addonAGD]: config.brandCode !== '0',
      })}
      headerClassName={styles.accordironAddonsHeader}
      titleClass={styles.accordionAddonsTitle}
      iconClassName={styles.accordionIcon}
      contentClassName={styles.accordionContent}
      data-testid="suggested-products"
    >
      <div className={styles.suggestedProductsList}>
        <Addon<ProductAddonElement>
          data={productsList}
          renderAddonItem={(product) => (
            <AddonCard
              data={product}
              onAddProduct={async () => await addProduct([{ productSKU: product.sku, product }])}
            />
          )}
        />
      </div>
    </Accordion>
  ) : null;
}

const SuggestedProducts = memo(SuggestedProductsComponent);

export default SuggestedProducts;
